var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotifyWish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D9F5E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8846 12.5H24.9231L23.641 15H23.2051L21.3718 10H18.9103L17.1667 15H16.7436L15.4615 12.5H12.5V22.5C12.5 26.6421 15.944 30 20.1923 30C24.4407 30 27.8846 26.6421 27.8846 22.5V12.5ZM13.7821 13.75H14.6667L15.9487 16.25H18.0898L19.8334 11.25H20.4744L22.3077 16.25H24.4359L25.718 13.75H26.6026V18.75H13.7821V13.75ZM13.7821 22.5C13.7821 25.9518 16.6521 28.75 20.1923 28.75C23.7326 28.75 26.6026 25.9518 26.6026 22.5V20H13.7821V22.5Z",
    fill: "#00B956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifyWish);
export default __webpack_public_path__ + "static/media/icon-notify-wish.987345d23b296eb14ece1ac7706374ea.svg";
export { ForwardRef as ReactComponent };